import React, { ReactNode, useCallback, useMemo } from 'react';
import Multiselect, { MultiselectOption } from '@rio-cloud/rio-uikit/Multiselect';

type StatusFilterComponentProps = {
    isLoading: boolean;
    title: ReactNode;
    placeholder: string;
    filterOptions: MultiselectOption[];
    onSelect: Function;
};

// Disabling the no-shadow as this is a bug from eslint with typescript
// eslint-disable-next-line no-shadow
export const enum Criticality {
    CRITICAL = 'CRITICAL',
    WARNING = 'WARNING',
    OK = 'OK',
}

const getAllFilterOptionsIds = (filterOptions: MultiselectOption[]): string[] => {
    return filterOptions.map((filter) => filter.id);
};

const CriticalityFilter = ({ isLoading, title, placeholder, filterOptions, onSelect }: StatusFilterComponentProps) => {
    const filterOptionsWithSelection = useMemo(
        () => filterOptions.map((filter) => ({ ...filter, disabled: isLoading })),
        [filterOptions, isLoading],
    );
    const onChange = useCallback(
        (selectedOptionsArray: any[]) => {
            let newSelectedOptionsArray = [...selectedOptionsArray];
            if (newSelectedOptionsArray.length === 0) {
                // whenever user tries to deselect the last item, select all items instead
                newSelectedOptionsArray = getAllFilterOptionsIds(filterOptions);
            }
            // all options selected is the same of no filters to be applied
            onSelect(newSelectedOptionsArray.length === filterOptions.length ? [] : newSelectedOptionsArray);
        },
        [filterOptions, onSelect],
    );
    return (
        <div className="display-flex flex-column min-width-200" data-testid="criticality-filter-component">
            <div className="display-flex align-content-start gap-10">
                <span className="text-color-highlight-light margin-bottom-10">{title}</span>
            </div>
            <Multiselect
                disabled={isLoading}
                placeholder={placeholder}
                options={filterOptionsWithSelection}
                onChange={onChange}
                showSelectedItemIcon
                showUnselectedItemIcons
            />
        </div>
    );
};

export default CriticalityFilter;
